import React from 'react';
import { RenderAppropriate } from '../../internals/RenderAppropriate';

import { HeadingOneStyle } from '../../styles/typography/heading.styles';

interface OneProps {
    children?: React.ReactNode;
    component?: React.ElementType;
    [key: string]: any;
}

interface OneComponent extends React.FC<OneProps> {
    Style?: typeof HeadingOneStyle;
}
export const One: OneComponent = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(HeadingOneStyle, rest, children, Component);

One.Style = HeadingOneStyle;
